import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { keys } from '@/lib/queryKeys';
import { fetchAiCallLog, fetchAiCallLogDetail, fetchAiCallLogSummary, rescanAiCallLog } from './api';
import type { AiCallLogFilters } from './types';

export function useAiCallLog(filters: AiCallLogFilters) {
  return useQuery({
    queryKey: keys.admin.aiCallLog(filters as Record<string, unknown>),
    queryFn: () => fetchAiCallLog(filters),
  });
}

export function useAiCallLogDetail(id: number | null) {
  return useQuery({
    queryKey: keys.admin.aiCallLogDetail(id ?? 0),
    queryFn: () => fetchAiCallLogDetail(id as number),
    enabled: id != null,
  });
}

export function useAiCallLogSummary() {
  return useQuery({ queryKey: keys.admin.aiCallLogSummary(), queryFn: fetchAiCallLogSummary });
}

export function useRescanAiCallLog() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (range: { from?: string; to?: string }) => rescanAiCallLog(range),
    onSuccess: () => { qc.invalidateQueries({ queryKey: keys.admin.aiCallLog() }); },
  });
}
